import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CatalogPartsView } from "src/components/views/erp/parts/catalogPart/CatalogPartsView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/productManagement/catalogParts")({
	staticData: { title: i18n.t("part_catalog"), legacyViewKey: "catalogPartsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <CatalogPartsView isActive={isActive} />;
}
